<template>
  <div>
    <v-card max-width="400" class="mx-auto mt-5">
      <v-card-title>
        <h2 class="title">Establecer contraseña</h2>
      </v-card-title>

      <v-card-text>
        <v-form ref="form" v-model="validForm">
          <v-text-field
            label="Contraseña"
            :type="showPassword ? 'text' : 'password'"
            prepend-icon="mdi-lock"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword"
            :rules="[rules.required, rules.passwordLenght]"
            v-model="password"
          ></v-text-field>
          <v-text-field
            label="Repetir contraseña"
            :type="showPassword ? 'text' : 'password'"
            prepend-icon="mdi-lock"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword"
            :rules="[rules.required, rules.passwordVerify]"
            v-model="passwordCkeck"
          ></v-text-field>
        </v-form>
        <v-alert type="success" v-if="message">
          {{ message }}
        </v-alert>
        <v-alert type="error" v-if="errorMessage">
          {{ errorMessage }}
        </v-alert>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="primary" outlined @click="$router.push('/login')"
          >INICIAR SESIÓN</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          :loading="loading"
          :disabled="message != '' || !validForm"
          color="primary"
          @click="registrar"
          >ESTABLECER</v-btn
        >
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import axios from "../axios-auth";
export default {
  data() {
    return {
      correo: "",
      cedula: "",
      password: "",
      passwordCkeck: "",
      validForm: false,
      dialog: false,
      snackbar: false,
      message: false,
      showPassword: false,
      errorMessage: "",
      loading: false,

      rules: {
        required: value => !!value || "Requerido.",
        passwordVerify: value =>
          value == this.password || "Las contraseñas no coinciden.",
        number: value => {
          const pattern = /^[0-9]+$/;
          return pattern.test(value) || "Ingrese solo números";
        },
        counter: value => value.length > 5 || "Ingrese un nombre valido",
        passwordLenght: value =>
          value.length >= 6 || "Debe contener al menos 6 caracteres"
      }
    };
  },
  mounted() {
    if (this.$route.query.token) {
      // axios
      //   .post("/singup/setPassword", {
      //     token: this.$route.query.token,
      //     newPassword: this.password
      //   })
      //   .then(response => {
      //     console.log(response);
      //     this.message = "";
      //     this.errorMessage = "";
      //     // if (response.data.emailVerificado) {
      //     //   this.message =
      //     //     "Su direccion de correo fue validado!. En breve un personal autorizado de APA se pondra en contacto con usted!";
      //     // }
      //   })
      //   .catch(err => {
      //     if (err && err.response && err.response.data) {
      //       this.errorMessage = err.response.data;
      //     } else {
      //       this.errorMessage = "Error";
      //     }
      //   });
    } else {
      //this.$router.push("/login");
    }
  },
  methods: {
    registrar() {
      this.loading = true;
      this.errorMessage = false;
      this.message = false;
      this.dialog = false;

      axios
        .post("/singup/setPassword", {
          token: this.$route.query.token,
          newPassword: this.password
        })
        .then(response => {
          this.loading = false;
          console.log(response);
          this.message = "";
          this.errorMessage = "";

          if (response.data == "OK") {
            this.message =
              "¡Se estableció la contraseña correctamente! Ya podés iniciar sesión";
          }
        })
        .catch(err => {
          this.loading = false;
          if (err && err.response && err.response.data) {
            this.errorMessage = err.response.data;
          } else {
            this.errorMessage = "Error";
          }
        });
    }
  }
};
</script>
